const settings = {
    // baseUrl: "https://localhost:7200",
    baseUrl: "https://api.jesta.com",
}

export default settings;